import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ITag } from '../../../../shared/interfaces/tags.interface';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'cv-tags',
  standalone: true,
  imports: [AccordionModule, TooltipModule],
  styleUrl: './tags.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <p-accordionTab [selected]="true" contentStyleClass="no-border no-padding" header="Conversation Tags">
      <div class="tags-wrapper">
        @for (tag of tags; track $index) {
          <div class="tag" [pTooltip]="tag.justification">{{ tag.tag }}</div>
        }
      </div>
    </p-accordionTab>
  `,
})
export class TagsComponent {
  @Input({ required: true }) tags: ITag[] | null = [];
}
